export type EventParticipantKind = "wedding" | "birthday" | "corporate" | "other";

export interface EventParticipantLabels {
  primary: string;
  secondary: string;
}

function normalize(value: unknown) {
  return String(value || "").trim().toLowerCase();
}

export function getEventParticipantKind(value: unknown): EventParticipantKind {
  const text = normalize(value).replace(/[_-]+/g, " ");

  if (text.includes("wedding") || text.includes("reception")) {
    return "wedding";
  }

  if (text.includes("birthday")) {
    return "birthday";
  }

  if (text.includes("corporate")) {
    return "corporate";
  }

  return "other";
}

export function getEventParticipantLabels(value: unknown): EventParticipantLabels {
  const kind = getEventParticipantKind(value);

  if (kind === "wedding") {
    return { primary: "Groom", secondary: "Bride" };
  }

  if (kind === "birthday") {
    return { primary: "Name", secondary: "Second Birthday Person" };
  }

  if (kind === "corporate") {
    return { primary: "Contact Person", secondary: "Second Contact" };
  }

  return { primary: "Name", secondary: "Second Name" };
}
